import React, { useEffect, useState } from 'react';
import { Star, StarBorder } from '@mui/icons-material';

// Utils
import { isNullUndefined } from '@/main/services/utils';
import { getStars } from '@/main/services/data/data';
import { KeyValue } from '@/main/models/common';

// Components
import TooltipComponent from '../tooltip/tooltipComponent';

let filledStarsClicked = 0;
interface IStarRatingVoteProps {
  readonly: boolean;
  onChangeRating: (rating: number) => void;
  rating?: number;
  size?: number;
}
function StarRatingVote({
  rating,
  readonly,
  onChangeRating,
  size
}: IStarRatingVoteProps) {
  // States
  const [filledStars, setFilledStars] = useState<number>(0);
  // Constants
  const PREFIX_ID_STAR = 'id-evaluationSupplier-star-';

  // Functions
  const handleMouseEnter = (index: number) => {
    if (!readonly) {
      setFilledStars(index + 1);
    }
  };
  const handleMouseLeave = () => {
    if (!readonly) {
      if (filledStarsClicked > 0) {
        setFilledStars(filledStarsClicked);
      } else setFilledStars(0);
    }
  };
  const onClickStar = (vote: number) => {
    if (!readonly) {
      const ratingVote = vote;
      filledStarsClicked = ratingVote;
      setFilledStars(ratingVote);

      onChangeRating(ratingVote);
    }
  };

  // UseEffect's
  useEffect(() => {
    if (!isNullUndefined(rating) && rating >= 0) {
      setFilledStars(rating);
      filledStarsClicked = rating;
    }
  }, [rating]);

  return (
    <div onMouseLeave={handleMouseLeave} className="d-flex">
      {getStars().map((item: KeyValue, index: number) => {
        return (
          <div
            className={readonly ? '' : 'cursor-pointer'}
            key={index}
            onMouseEnter={() => handleMouseEnter(index)}
            onClick={() => onClickStar(Number(item.key))}>
            {index < filledStars ? (
              <StarRatingTooltip
                id={`${PREFIX_ID_STAR}${Number(item.key)}`}
                filled={true}
                tooltipText={item.value}
                size={size}
              />
            ) : (
              <StarRatingTooltip
                id={`${PREFIX_ID_STAR}${Number(item.key)}`}
                filled={false}
                tooltipText={item.value}
                size={size}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

interface IStarRatingTooltipProps {
  filled: boolean;
  tooltipText: string;
  id: string;
  size?: number;
}
const StarRatingTooltip = ({
  filled,
  tooltipText,
  size,
  id
}: IStarRatingTooltipProps) => {
  const styleIcons = { fontSize: size || 32 };

  const icon = filled ? (
    <Star id={id} className="star-color__default" style={styleIcons} />
  ) : (
    <StarBorder id={id} className="star-color__default" style={styleIcons} />
  );

  return (
    <TooltipComponent title={<div>{tooltipText}</div>}>{icon}</TooltipComponent>
  );
};

export default StarRatingVote;
